import { array, TArrayCodec } from "../../../shared/src/codecs/types/array";
import { boolean, TBooleanCodec } from "../../../shared/src/codecs/types/boolean";
import { required, TRequiredCodec } from "../../../shared/src/codecs/types/required";
import { string, TAnyStringCodec } from "../../../shared/src/codecs/types/string";
import { CasesSearchForm, TCasesSearchFormCodec } from "../form/CasesSearchForm";
import { TEmailCompositionFormCodec, EmailCompositionForm } from "../form/EmailCompositionForm";
import { DetailedEmailForm, TDetailedEmailFormCodec } from "../form/TriageForm";
import { CaseDocumentTileInfo1 } from "../FileEmailAttachmentsToDocStore";

type TCaseDocumentTileInfoCodec = typeof CaseDocumentTileInfo1;

type TGlobalLegalPartial = TRequiredCodec<{
    cases_search: TCasesSearchFormCodec;
    compose_email: TEmailCompositionFormCodec;
    compose_email_is_open: TBooleanCodec;
    attached_email: TDetailedEmailFormCodec;
    additional_compose_email_addresses: TArrayCodec<TAnyStringCodec>;
    file_attachments_assignment_is_open: TBooleanCodec;
    file_attachments_assignment_email: TDetailedEmailFormCodec;
    file_attachments_assignment_case_id: TAnyStringCodec;
    file_attachments_assignment_existing_tiles: TArrayCodec<TCaseDocumentTileInfoCodec>;
}>;

export const GlobalLegalPartial: TGlobalLegalPartial = required({
    cases_search: CasesSearchForm,
    compose_email: EmailCompositionForm,
    compose_email_is_open: boolean(),
    attached_email: DetailedEmailForm,
    additional_compose_email_addresses: array(string()),
    file_attachments_assignment_is_open: boolean(),
    file_attachments_assignment_email: DetailedEmailForm,
    file_attachments_assignment_case_id: string(),
    file_attachments_assignment_existing_tiles: array(CaseDocumentTileInfo1),
});
export type TGlobalLegalPartialCodec = typeof GlobalLegalPartial;